<template :key="`search-${searchKey}`">
  <v-container fluid class="pContainer pa-0">
    <v-sheet
      class="d-flex align-center flex-grow-1"
      v-if="loading && totalCount == 0 && !isError"
    >
      <Loading class="align-stretch"></Loading>
    </v-sheet>

    <div v-else class="pContainer-Body pt-0">
      <!-- 検索欄 -->
      <section class="pWrap pt-4">
        <!-- 検索条件の表示 -->
        <PortalSearchResultView
          :screen="0"
          :type="type"
          :keyword="keyword"
          :creatorKbn="creatorKbn"
          :tags="tags"
          :liked="liked"
          :opend="opend"
          :ocWorld="ocWorld"
          :ocItem="ocItem"
          :totalCount="totalCount"
          :shouhinKbnList="shouhinKbnList"
          :worldList="worldList"
          :creatorTagsList="creatorTagsList"
          :cId="cId"
          :worldId="worldId"
          :creatorId="creatorId"
          :shouhinKbn="shouhinKbn"
          :firstItem="firstItem"
          @openDialog="$refs.portalSearchDialog.open()"
        />
        <!-- TODO:ソート機能／デフォルトは更新順 -->
        <v-btn-toggle
          class="pt-2"
          v-if="type != 'all'"
          mandatory
          v-model="selected"
        >
          <v-btn
            small
            :color="ColorGray2"
            v-for="(btn, index) in type == 'creator' ? sortList : sortList2"
            :key="index"
            :value="btn.value"
            @click="sortProcessing(btn.value)"
          >
            {{ btn.text }}
          </v-btn>
        </v-btn-toggle>
      </section>

      <Add01 class="pt-4" />

      <section
        v-if="(type === 'all' && creatorList.length != 0) || type === 'creator'"
        class="pWrap"
      >
        <h1 v-if="type === 'all'" class="fs-l">
          クリエイター<span
            class="d-inline-block fs-xs fc-gray-4 pl-2 font-weight-medium"
            >{{ creatorListCount }}件</span
          >
        </h1>
        <div
          v-if="!loading && creatorList.length == 0"
          class="text-center fs-s fc-gray-6 py-8"
        >
          クリエイターは見つかりませんでした
        </div>
        <div class="creatorList">
          <template v-for="(item, index) in creatorList">
            <div
              class="creatorList-Unit col-12 col-sm-4 col-md-3 col-lg-2"
              :key="`creator${index}`"
            >
              <CreatorCard
                @clickFav="clickFav(item.creatorId)"
                :item="item"
                :loading="loading"
              ></CreatorCard>
            </div>
            <div
              class="creatorList-Unit col-12 col-sm-4 col-md-3 col-lg-2"
              :key="`creator${index + 0.5}`"
              v-if="index % 24 == 0 && index != 0"
            >
              <Add04 />
            </div>
          </template>
        </div>
        <v-layout
          v-if="type === 'all' && creatorList.length == 6"
          class="d-flex justify-center pt-4 pb-8"
        >
          <v-btn
            rounded
            :color="ColorTextSub"
            depressed
            dark
            width="240px"
            :to="{
              name: $route.name,
              query: $route.query,
              params: {
                keyword: $route.params.keyword,
                type: 'creator',
              },
            }"
            class="font-weight-bold"
            >もっと見る</v-btn
          >
        </v-layout>
      </section>

      <!-- ボイス -->
      <section
        v-if="(type === 'all' && voiceList.length != 0) || type === 'voice'"
        class="pWrap voiceList"
      >
        <h1 v-if="type === 'all'" class="fs-l">
          ボイス<span
            class="d-inline-block fs-xs fc-gray-4 pl-2 font-weight-medium"
            >{{ voiceListCount }}件</span
          >
        </h1>
        <div
          v-if="!loading && voiceList.length == 0"
          class="text-center fs-s fc-gray-6 py-8"
        >
          作品は見つかりませんでした
        </div>
        <GalleryVoiceList :voiceList="voiceList" screenType="1" />
        <v-layout
          v-if="type === 'all' && voiceList.length == 16"
          class="d-flex justify-center pt-4 pb-8"
        >
          <v-btn
            rounded
            :color="ColorTextSub"
            depressed
            dark
            width="240px"
            :to="{
              name: $route.name,
              query: $route.query,
              params: {
                keyword: $route.params.keyword,
                type: 'voice',
              },
            }"
            class="font-weight-bold"
            >もっと見る</v-btn
          >
        </v-layout>
      </section>

      <!-- ノベル -->
      <section
        v-if="(type === 'all' && novelList.length != 0) || type === 'novel'"
        class="pWrap"
      >
        <h1 v-if="type === 'all'" class="fs-l">
          ノベル<span
            class="d-inline-block fs-xs fc-gray-4 pl-2 font-weight-medium"
            >{{ novelListCount }}件</span
          >
        </h1>
        <div
          v-if="!loading && novelList.length == 0"
          class="text-center fs-s fc-gray-6 py-8"
        >
          作品は見つかりませんでした
        </div>
        <GalleryNovelList :novelList="novelList" screenType="1" />
        <v-layout
          v-if="type === 'all' && novelList.length == 12"
          class="d-flex justify-center pt-4 pb-8"
        >
          <v-btn
            rounded
            :color="ColorTextSub"
            depressed
            dark
            width="240px"
            :to="{
              name: $route.name,
              query: $route.query,
              params: {
                keyword: $route.params.keyword,
                type: 'novel',
              },
            }"
            class="font-weight-bold"
            >もっと見る</v-btn
          >
        </v-layout>
      </section>

      <!-- イラスト)-->
      <section
        v-if="(type === 'all' && illustList.length != 0) || type === 'illust'"
        class="pWrap"
      >
        <h1 v-if="type === 'all'" class="fs-l">
          イラスト<span
            class="d-inline-block fs-xs fc-gray-4 pl-2 font-weight-medium"
            >{{ illustListCount }}件</span
          >
        </h1>
        <div
          v-if="!loading && !isError && illustList.length == 0"
          class="text-center fs-s fc-gray-6 py-8"
        >
          作品は見つかりませんでした
        </div>
        <GalleryIllustList
          　ref="galleryIllustList"
          :illustList="illustList"
          screenType="1"
        />
      </section>
    </div>

    <div v-show="!loading" class="il">
      <infinite-loading
        ref="infiniteLoading"
        spinner="waveDots"
        @infinite="infiniteLoad"
      >
        <div slot="no-more">
          <v-img
            :src="`${assetsPath}/p/img/alpaca.png`"
            width="64"
            class="mx-auto my-4"
            style="opacity: 0.8;"
          />
        </div>
        <div class="mx-4" slot="no-results">
          <section
            v-if="
              type === 'all' &&
              !loading &&
              !isError &&
              creatorList.length +
                illustList.length +
                voiceList.length +
                novelList.length ==
                0
            "
            class="text-center fs-s fc-gray-6 py-8"
          >
            作品は見つかりませんでした
          </section>

          <v-alert
            v-if="isError"
            color="var(--gray-2)"
            border="left"
            icon="error"
            class="text-left mx-auto"
            max-width="800"
          >
            <div class="font-weight-bold pb-1">
              何かがおかしいようです <v-icon>ai-alpaca</v-icon>💦
            </div>
            <div>
              検索条件を確認してください。<br />繰り返し失敗する場合は、アルパカコネクトまでお問い合わせください。
            </div>
          </v-alert>

          <v-img
            v-else
            :src="`${assetsPath}/p/img/alpaca.png`"
            width="64"
            class="mx-auto my-4"
            style="opacity: 0.8;"
          />
        </div>
      </infinite-loading>
    </div>
    <!--<v-sheet class="py-4" color="var(--c-body)">
      <Add01 />
    </v-sheet>-->
    <!-- 検索条件変更ダイアログ -->
    <PortalSearchDialog
      ref="portalSearchDialog"
      :screen="0"
      :type="type"
      :keyword="keyword"
      :creatorKbn="creatorKbn"
      :tags="tags"
      :liked="liked"
      :opend="opend"
      :ocWorld="ocWorld"
      :ocItem="ocItem"
      :cId="cId"
      :worldId="worldId"
      :creatorId="creatorId"
      :shouhinKbn="shouhinKbn"
    />
  </v-container>
</template>

<script>
import axios from "axios";
import CreatorCard from "@/views/tailor/creatorCard";
import PortalSearchDialog from "@/views/portalSearch/portalSearchDialog";
import PortalSearchResultView from "@/views/portalSearch/portalSearchResultView";
import GalleryIllustList from "@/views/tailor/galleryIllustList";
import GalleryNovelList from "@/views/tailor/galleryNovelList";
import GalleryVoiceList from "@/views/tailor/galleryVoiceList";
import InfiniteLoading from "vue-infinite-loading";
import Add04 from "@/components/add/Add04";
import Add01 from "@/components/add/Add01";

export default {
  name: "portalSearchResultComp",
  components: {
    CreatorCard,
    GalleryIllustList,
    GalleryNovelList,
    GalleryVoiceList,
    PortalSearchDialog,
    PortalSearchResultView,
    InfiniteLoading,
    Add04,
    Add01,
  },

  props: {
    // searchKey: {
    //   mode: Number,
    //   required: true,
    // },
    keyword: {
      mode: String,
      required: false,
      default: "",
    },
    creatorKbn: {
      mode: Number,
      required: false,
      default: 0,
    },
    tags: {
      mode: Array,
      required: false,
    },
    liked: {
      mode: Boolean,
      default: false,
    },
    opend: {
      mode: Boolean,
      default: false,
    },
    ocItem: {
      mode: Array,
      required: false,
    },
    ocWorld: {
      mode: Array,
      required: false,
    },
    type: {
      mode: String,
      required: false,
      default: "all",
    },
    s: {
      mode: String,
      required: false,
      default: "1",
    },
    cId: {
      mode: String,
      default: false,
    },
    worldId: {
      mode: String,
      default: false,
    },
    creatorId: {
      mode: Number,
      required: false,
    },
    shouhinKbn: {
      mode: String,
      required: false,
    },
  },
  inject: ["getLikedInfo", "searchReload", "reload"],
  data() {
    return {
      userId: "",

      illustList: [],
      voiceList: [],
      novelList: [],
      creatorList: [],
      illustListCount: 0,
      voiceListCount: 0,
      novelListCount: 0,
      creatorListCount: 0,
      itemCount: 0,
      page: 1,
      loading: false,
      isError: false,
      p: {},

      selected: "1",
      parm_s: "nouhinDate",
      parm_a: "DESC",

      perPage: 24,

      //並び替え詳細
      //ふぇ〜とお気に入りはプレミアム
      sortList: [
        { value: "1", text: "更新順" },
        { value: "2", text: "納品順" },
        // { value: "3", text: "お気に入り順" },
        // { value: "4", text: "ふぇ〜順" },
        { value: "5", text: "納品数順" },
        { value: "6", text: "登録が新しい順" },
        { value: "7", text: "登録が古い順" },
      ],
      sortList2: [
        { value: "1", text: "新しい順" },
        { value: "2", text: "古い順" },
      ],

      shouhinKbnList: [],
      worldList: [],
      creatorTagsList: [],
      parm_tags: [],
      parm_ocItem: [],
      parm_ocWorld: [],
    };
  },

  computed: {
    // _propsStatus() {
    //   return [
    //     this.$props.keyword,
    //     this.$props.creatorKbn,
    //     this.$props.tags,
    //     this.$props.liked,
    //     this.$props.opend,
    //     this.$props.ocItem,
    //     this.$props.ocWorld,
    //     this.$props.type,
    //     this.$props.s,
    //     this.$props.cId,
    //     this.$props.worldId,
    //     this.$props.creatorId,
    //     this.$props.shouhinKbn,
    //   ];
    // },

    totalCount() {
      return (
        this.illustListCount +
        this.voiceListCount +
        this.novelListCount +
        this.creatorListCount
      );
    },

    shouhinShubetsu() {
      let result;
      switch (this.type) {
        case "all":
        case "illust":
          result = 1;
          break;
        case "voice":
          result = 2;
          break;
        case "novel":
          result = 3;
          break;
        default:
          result = 0;
          break;
      }
      return result;
    },

    firstItem() {
      if (this.illustListCount != 0) {
        return this.illustList[0];
      } else if (this.novelListCount != 0) {
        return this.novelList[0];
      } else if (this.voiceListCount != 0) {
        return this.voiceList[0];
      } else if (this.creatorListCount != 0) {
        return this.creatorList[0];
      } else {
        return "";
      }
    },
  },

  watch: {
    liked: {
      handler: function (val) {
        if (val) {
          this.getLikedInfo();
        }
      },
      deep: true,
      immediate: true,
    },
    // $props: {
    //   handler: async function (val, oldval) {
    //     this.reset();
    //     // console.log(JSON.stringify(val));
    //     // console.log(this.p);
    //     // if (JSON.stringify(val) != this.p) {
    //     //   console.log("reset");

    //     // } else {
    //     //   console.log("keep");
    //     // }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },

  created() {
    this.userId = this.$store.state.userId;
    if (this.type == "all") {
      this.initialSearch();
    }

    if (this.s) {
      this.selected = this.s;
      this.parm_s = this.s;
    }
  },

  methods: {
    async reset() {
      Object.assign(this.$data, this.$options.data.call(this));
      this.userId = this.$store.state.userId;
      if (this.type == "all") {
        await this.initialSearch();
      }
      if (this.$refs.infiniteLoading) {
        await this.$refs.infiniteLoading.stateChanger.reset();
      }
      // this.p = JSON.stringify(this.$props);
    },

    async initialSearch() {
      this.loading = true;

      //キーワードを配列に
      let searchWord;
      if (this.keyword) {
        const new_arr1 = this.keyword.split(/ |　/); //配列に変換
        const new_arr2 = new_arr1.filter(function (x) {
          return !(x === "");
        }); //空欄の削除
        const new_arr3 = [...new Set(new_arr2)]; //重複の削除
        searchWord = new_arr3;
      } else {
        searchWord = "";
      }
      let params = "";
      if (this.cId) {
        params = "&cId=" + this.cId;
      } else if (this.worldId) {
        params = "&worldId=" + this.worldId;
      } else if (this.creatorId) {
        params = "&creatorId=" + this.creatorId;
      } else if (this.shouhinKbn) {
        params = "&shouhinKbn=" + this.shouhinKbn;
      }

      await axios
        .get(
          this.serverPath +
            "/api/GallerySearch/initialSearchResult?sortBy=" +
            this.parm_s +
            "&searchWord=" +
            searchWord +
            params
        )
        .then(async (res) => {
          //検索結果へ追加
          // if (res.data.illustList != null) {
          //   this.illustList = res.data.illustList;
          //   this.illustListCount = res.data.illustListCount;
          // }
          if (res.data.voiceList != null) {
            this.voiceList = res.data.voiceList;
            this.voiceListCount = res.data.voiceListCount;
          }
          if (res.data.novelList != null) {
            this.novelList = res.data.novelList;
            this.novelListCount = res.data.novelListCount;
          }
          if (res.data.creatorList != null) {
            this.creatorList = res.data.creatorList;
            this.creatorListCount = res.data.creatorListCount;
          }

          this.infiniteLoad(this.$refs.infiniteLoading.stateChanger);

          this.loading = false;
        })
        //接続エラー
        .catch((error) => {
          console.log(error);
          this.isError = true;
          this.loading = false;
        });
    },

    infiniteLoad: async function ($state) {
      this.fullPath = this.$route.fullPath;
      this.loading = true;

      // if (this.type == "all" && this.itemCount == 0) {
      //   this.itemCount = 10;
      // }
      var pageStart = this.itemCount;

      if (this.type != "creator") {
        //キーワードを配列に
        let searchWord;
        if (this.keyword) {
          const new_arr1 = this.keyword.split(/ |　/); //配列に変換
          const new_arr2 = new_arr1.filter(function (x) {
            return !(x === "");
          }); //空欄の削除
          const new_arr3 = [...new Set(new_arr2)]; //重複の削除
          searchWord = new_arr3;
        } else {
          searchWord = "";
        }

        let params = "";
        if (this.cId) {
          params = "&cId=" + this.cId;
        } else if (this.worldId) {
          params = "&worldId=" + this.worldId;
        } else if (this.creatorId) {
          params = "&creatorId=" + this.creatorId;
        } else if (this.shouhinKbn) {
          params = "&shouhinKbn=" + this.shouhinKbn;
        }

        await axios
          .get(
            this.serverPath +
              "/api/GallerySearch/detailSearchResult?searchWord=" +
              searchWord +
              "&shouhinShubetsu=" +
              this.shouhinShubetsu +
              "&ascOrDesc=" +
              this.parm_a +
              "&sortBy=" +
              this.parm_s +
              "&pageStart=" +
              pageStart +
              "&perPage=" +
              this.perPage +
              params
          )
          .then(async (res) => {
            let list;
            //検索結果へ追加
            if (this.type == "voice") {
              list = res.data.voiceList;
              this.voiceList.push(...list);
              this.voiceListCount = res.data.voiceListCount;
            } else if (this.type == "novel") {
              list = res.data.novelList;
              this.novelList.push(...list);
              this.novelListCount = res.data.novelListCount;
            } else {
              list = res.data.illustList;
              this.illustList.push(...list);
              this.illustListCount = res.data.illustListCount;
            }

            const resCount = list.length;
            this.itemCount += this.perPage;
            this.isError = false;
            if (resCount == this.perPage) {
              $state.loaded();
            } else {
              $state.complete();
            }
          })
          //接続エラー
          .catch((error) => {
            console.log(error);
            $state.complete();
            this.isError = true;
            this.loading = false;
          });
      } else {
        if (!this.tags) {
          this.parm_tags = "";
        } else {
          this.parm_tags = this.tags;
        }
        if (!this.ocItem) {
          this.parm_ocItem = "";
        } else {
          this.parm_ocItem = this.ocItem;
        }
        if (!this.ocWorld) {
          this.parm_ocWorld = "";
        } else {
          this.parm_ocWorld = this.ocWorld;
        }

        await axios
          .get(
            this.serverPath +
              "/api/Tailor/searchCreatorName?userId=" +
              this.userId +
              "&keyword=" +
              this.keyword +
              "&creatorKbn=" +
              this.creatorKbn +
              "&tags=" +
              this.parm_tags +
              "&liked=" +
              this.liked +
              "&opend=" +
              this.opend +
              "&ocItem=" +
              this.parm_ocItem +
              "&ocWorld=" +
              this.parm_ocWorld +
              "&type=" +
              this.type +
              "&sort=" +
              this.parm_s +
              "&startRow=" +
              pageStart +
              "&perPage=" +
              this.perPage
          )
          .then(async (res) => {
            //検索結果へ追加
            for (var i = 0; i < res.data.creatorCardDto.length; i++) {
              let item = res.data.creatorCardDto[i];
              this.creatorList.push(item);
            }
            this.shouhinKbnList = res.data.shouhinKbnListDto;
            this.worldList = res.data.worldNameDto;
            this.creatorTagsList = res.data.creatorTagInfoDto;
            this.itemCount += this.perPage;
            this.creatorListCount = this.creatorList.length;
            if (res.data.creatorCardDto.length > 0) {
              this.creatorListCount = res.data.creatorCardDto[0].allCnt;
            } else {
              this.creatorListCount = 0;
            }

            this.isError = false;
            if (res.data.creatorCardDto.length == this.perPage) {
              $state.loaded();
            } else {
              $state.complete();
            }
          })
          //接続エラー
          .catch((error) => {
            console.log(error);
            $state.complete();
            this.isError = true;
            this.loading = false;
          });
      }
      this.loading = false;
    },

    //表示順の変更
    sortProcessing: async function (sortKey) {
      if (this.type != "creator" && this.parm_s != sortKey) {
        this.userId = this.$store.state.userId;
        this.voiceList = [];
        this.novelList = [];
        this.illustList = [];
        this.itemCount = 0;
        this.creatorListCount = 0;
        this.parm_s = "nouhinDate";
        this.parm_a = sortKey == 1 ? "DESC" : "ASC";
        this.$refs.infiniteLoading.stateChanger.reset();
      } else if (this.parm_s != sortKey) {
        this.userId = this.$store.state.userId;
        this.creatorList = [];
        this.itemCount = 0;
        this.creatorListCount = 0;
        this.parm_s = sortKey;
        this.$refs.infiniteLoading.stateChanger.reset();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/import.scss";

.pContainer {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  margin-bottom: 0;
  // &-Body {
  //   @include baseBox;
  //   max-width: inherit;
  // }
}

.pWrap {
  flex-grow: 0;
  background-color: var(--white);
  border-top: solid 1px var(--c-border);
  border-bottom: solid 1px var(--c-border);
  @include baseBox;

  padding-top: 32px !important;
  padding-bottom: 32px !important;
  max-width: inherit;
  margin-top: 8px !important;

  &:first-child {
    border-top: none;
    margin-top: 0 !important;
  }

  &:last-child {
    border-bottom: none;
    margin-bottom: 0 !important;
  }
}

.il {
  background-color: var(--white);
  margin: -16px 0;
  padding: 24px;
  flex-grow: 1;
  z-index: $z-content;
}

.gIl {
  margin-right: -16px;
  margin-left: -16px;
}
.creatorList {
  display: flex;
  margin: 0 -10px;
  flex-wrap: wrap;
  padding-right: 0;
  padding-left: 0;
}
</style>
